module.exports = __webpack_public_path__ + "img/logo.efe605d3.png";